/**
 * @group Network
 * @summary HTTP status codes for network errors
 * 
 * @remarks
 * This constant contains standard HTTP status codes used in API responses
 * for consistent error handling and success responses.
 * 
 * @example
 * ```typescript
 * import { HTTP_STATUS_CODES } from '@shared/constants';
 * 
 * if (!user) {
 *   return res.status(HTTP_STATUS_CODES.NOT_FOUND).json({ error: 'User not found' });
 * }
 * 
 * return res.status(HTTP_STATUS_CODES.OK).json({ data: user });
 * ```
 */
export const HTTP_STATUS_CODES = {
  // 2xx Success
  OK: 200,
  CREATED: 201,
  NO_CONTENT: 204,
  
  // 4xx Client Errors
  BAD_REQUEST: 400,
  UNAUTHORIZED: 401,
  FORBIDDEN: 403,
  NOT_FOUND: 404,
  METHOD_NOT_ALLOWED: 405,
  CONFLICT: 409,
  UNPROCESSABLE_ENTITY: 422,
  TOO_MANY_REQUESTS: 429,
  
  // 5xx Server Errors
  INTERNAL_SERVER_ERROR: 500,
  NOT_IMPLEMENTED: 501,
  BAD_GATEWAY: 502,
  SERVICE_UNAVAILABLE: 503,
  GATEWAY_TIMEOUT: 504,
} as const; 